export const moveElement = (from, to = '') => {
  const oldParent = document.querySelector(`#${from}`);
  const newParent = document.querySelector(`#${to}`);

  if (oldParent && newParent) {
    newParent.innerHTML = oldParent.innerHTML;
    oldParent.innerHTML = '';
  }
};

export const camelToKebab = str => str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
